import initializeApp, { Params } from 'Jsx/Shared/LayoutV2/initializeApp';

import App from './App';

import getInitialState from './getInitialState';

import { initialStatePageKey } from './constants';

const appConfig: Params = {
  App,
  getInitialState,
  i18nConfig: {
    pageKey: 'membership-landing-v2',
    defaults: {
      es: {},
      pt: {},
    },
  },
  layoutProps: {
    userActivityPageView: {
      type: 'membership',
    },
  },
  initialStatePageKey,
  extraState: {},
};

if (module.hot) {
  module.hot.accept('./App.tsx', () => {
    initializeApp(appConfig);
  });
}

initializeApp(appConfig);
